import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageWithInitials from "../../Utils/ImageWithInitials";
import { TrimString } from "../../Utils/StringTrimmer";
import { useAuth } from "../context/Auth";
import { ROUTE_PATHS } from "../../constants/app.constants";
import UserSidebarMenu from "../Common/user-sidebar-menu/user-sidebar-menu.component";

const Header = ({ isLoading, accountId, data, leftSideComponent }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const userDetails = useSelector((state) => state?.user?.userDetail);
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  return (
    <>
    <div className="d-lg-none">
      <SidebarMenu 
        setAuth={setAuth}
        userDetails={userDetails}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
    </div>
      <div
        className="w-100 bg-white d-flex align-items-center justify-content-between"
        style={{
          position: "sticky",
          top: "0px",
          height: "56px",
          minHeight: "56px",
          zIndex: 6,
          borderBottom: "1px solid #EBEDF1",
        }}
      >
        <div>
          {leftSideComponent}
          {!isLoading && accountId && (
            <h3 style={{ padding: '12px 24px', fontSize: '16px', lineHeight: '24px', fontWeight: '600' }}>
              {data?.UserDetail?.OrgName}
            </h3>
          )}
        </div>
        <div
          className="d-none d-lg-flex align-items-center pointer mr-3"
          onClick={() => {}}
        >
          <Dropdown className="transparennt-wrapper-dropdown">
            <Dropdown.Toggle>
              {userDetails.Avatar == "No URL" ? (
                <ImageWithInitials
                  width={31}
                  background="purple"
                  initials={userDetails?.Initials}
                />
              ) : (
                <img
                  alt=""
                  src={userDetails?.Avatar}
                  className="rounded-full"
                  style={{
                    width: "31px",
                    height: "31px",
                  }}
                />
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item disabled={true}>
                <div className="d-flex justify-content-between align-items-center ">
                  <div className="d-flex align-items-center">
                    {userDetails.Avatar == "No URL" ? (
                      <ImageWithInitials
                        width={31}
                        background="purple"
                        initials={userDetails?.Initials}
                      />
                    ) : (
                      <img
                        alt=""
                        src={userDetails?.Avatar}
                        className="rounded-full"
                        style={{
                          width: "31px",
                          height: "31px",
                        }}
                      />
                    )}

                    <div className="ml-2">
                      <p className="title m-0">
                        {TrimString(userDetails.FullName, 17)}
                      </p>
                      <p className="subtitle m-0">
                        {TrimString(userDetails.UserName, 17)}
                      </p>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </Dropdown.Item>
              <hr className="m-0" />
              <Dropdown.Item
                type="button py-2 my-1"
                onClick={() => {
                  window.localStorage.clear();
                  navigate(ROUTE_PATHS.authPages.login);
                  setAuth(false);
                }}
              >
                <img
                  alt=""
                  src="/images/settings-v2/logout.svg"
                  className="mr-2 v2-item-color"
                />
                <span className="f-grey-imp"> Logout</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="d-flex justify-content-end d-lg-none">
          <img 
            src="/images/menu.svg"
            width="24px"
            height="24px"
            alt="menu"
            className="mr-3 pointer"
            onClick={() => setIsSidebarOpen(true)}
          />
        </div>
      </div>
    </>
  );
};

export default Header; 

const SidebarMenu = ({
  setAuth,
  userDetails,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const navigate = useNavigate();
  const onClose = () => {
    setIsSidebarOpen(false);
  }
  return (
    <UserSidebarMenu
      isSidebarOpen={isSidebarOpen}
      setIsSidebarOpen={setIsSidebarOpen}
      userDetails={userDetails}
    >
      <div 
        className="d-flex align-items-center"
        onClick={() => {
          window.localStorage.clear();
          navigate(ROUTE_PATHS.authPages.login);
          setAuth(false);
          onClose();
        }}
      >
        <img
          alt=""
          src="/images/settings-v2/logout.svg"
          className="mr-2 v2-item-color"
        />
        <span className="f-grey-imp"> Logout</span>
      </div>
    </UserSidebarMenu>
  )
}
